import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                postUrl={api.proyectos.config.plantillas.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Plantilla ha sido creado con éxito."}
                title={"Nueva Plantilla"}
                buttonTitle={"Nueva Plantilla"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <PlantillaFormSections autoFocusFirstField={true} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/Create.js